import { transport } from "@/src/config/apiConfig.js";

export default {
  /* --------------- Knowledge Base APIs --------------- */
  async fetchKnowledgeBase() {
    try {
      let res = await transport.get(`/api/conversation/knowledge`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while fetching knowledge base: ", error);
      throw error;
    }
  },

  async updateKnowledgeBase(payload) {
    try {
      let res = await transport.put(
        `/api/conversation/knowledge/update`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating knowledge base: ", error);
      throw error;
    }
  },

  async deleteKnowledgeBase(id) {
    try {
      let res = await transport.delete(`/api/conversation/knowledge/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting knowledge base: ", error);
      throw error;
    }
  },

  /* --------------- Instructions APIs --------------- */
  async fetchInstructions() {
    try {
      let res = await transport.get(`/api/conversation/instructions`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while fetching instructions: ", error);
      throw error;
    }
  },

  async updateInstructions(payload) {
    try {
      let res = await transport.put(
        `/api/conversation/instructions/update`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating instruction: ", error);
      throw error;
    }
  },

  async deleteInstruction(id) {
    try {
      let res = await transport.delete(`/api/conversation/instructions/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting instruction: ", error);
      throw error;
    }
  },

  /* --------------- Widget Settings APIs --------------- */
  async fetchWidgetSettings() {
    try {
      let res = await transport.get(`/api/conversation/widget_settings`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while fetching widget settings: ",
        error,
      );
      throw error;
    }
  },

  async updateWidgetSettings(payload) {
    try {
      let res = await transport.put(
        "/api/conversation/widget_settings/update",
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating widget settings: ",
        error,
      );
      throw error;
    }
  },

  async deleteWidgetSettings(id) {
    try {
      let res = await transport.delete(
        `/api/conversation/widget_settings/${id}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while deleting widget settings: ",
        error,
      );
      throw error;
    }
  },

  /* --------------- Message APIs --------------- */

  async fetchMessagesByConversationID(id, page = 1, limit = 20) {
    try {
      let res = await transport.get(
        `/api/conversation/${id}/messages?page=${page}&limit=${limit}`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting messages by conversation ID: ",
        error,
      );
      throw error;
    }
  },

  async markMessageAsRead(id) {
    try {
      let res = await transport.put(
        `/api/conversation/${id}/messages/mark_read`,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while marking message as read: ", error);
      throw error;
    }
  },

  async fetchMessagesUnreadCount(id) {
    try {
      let res = await transport.get(
        `/api/conversation/${id}/messages/unread_count`,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting messages unread count: ",
        error,
      );
      throw error;
    }
  },

  async sendMessage(payload) {
    try {
      let res = await transport.post(`/api/conversation/message/send`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while sending message: ", error);
      throw error;
    }
  },

  async sendTypingIndicator(payload) {
    try {
      let res = await transport.post(
        `/api/conversation/typing/indicator`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while sending typing indicator: ",
        error,
      );
      throw error;
    }
  },

  async handOffToHuman(payload) {
    try {
      let res = await transport.post(
        `/api/conversation/handoff_to_human`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while handing off to human: ", error);
      throw error;
    }
  },

  async fetchMessageByID(id) {
    try {
      let res = await transport.get(`/api/conversation/message/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting message by ID: ", error);
      throw error;
    }
  },

  /* --------------- Conversation APIs --------------- */

  async fetchConversations(params) {
    try {
      let res = await transport.get(`/api/conversation`, { params: params });
      return res.data;
    } catch (error) {
      console.error("An error occurred while getting conversations: ", error);
      throw error;
    }
  },

  async fetchConversationByID(id) {
    try {
      let res = await transport.get(`/api/conversation/${id}`);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting conversation by ID: ",
        error,
      );
      throw error;
    }
  },

  async fetchConversationsByEntity(payload) {
    try {
      let res = await transport.post(`/api/conversation/entity`, payload);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while getting conversations by entity: ",
        error,
      );
      throw error;
    }
  },

  async initiateConversation(id) {
    try {
      let res = await transport.post(`/api/conversation/initiate`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while initiate conversation: ", error);
      throw error;
    }
  },

  async updateConversationStatus(id, payload) {
    try {
      let res = await transport.put(`/api/conversation/${id}/status`, payload);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while updating conversation status: ",
        error,
      );
      throw error;
    }
  },

  async assignConversationAgent(id, payload) {
    try {
      let res = await transport.put(`/api/conversation/${id}/assign`, payload);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while assigning conversation agent: ",
        error,
      );
      throw error;
    }
  },

  async resolveConversation(id, payload) {
    try {
      let res = await transport.put(`/api/conversation/${id}/resolve`, payload);
      return res.data;
    } catch (error) {
      console.error("An error occurred while resolving conversation: ", error);
      throw error;
    }
  },

  async manageStarConversation(id, payload) {
    try {
      let res = await transport.put(`/api/conversation/${id}/star`, payload);
      return res.data;
    } catch (error) {
      console.error(
        "An error occurred while managing star conversation: ",
        error,
      );
      throw error;
    }
  },

  async addAnonymousUser(payload) {
    try {
      let res = await transport.post(
        `/api/conversation/add/anonymous_user`,
        payload,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while adding anonymous user: ", error);
      throw error;
    }
  },

  async uploadAttachments(payload) {
    try {
      let res = await transport.post(
        `/api/conversation/attachments/upload`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while uploading attachments: ", error);
      throw error;
    }
  },

  async downloadAttachment(id) {
    try {
      let res = await transport.get(
        `/api/conversation/attachments/download/${id}`,
        {
          responseType: "blob",
        },
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while downloading attachment: ", error);
      throw error;
    }
  },

  async deleteAttachment(id) {
    try {
      let res = await transport.delete(
        `/api/conversation/attachments/delete/${id}`,
      );
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting attachment: ", error);
      throw error;
    }
  },

  /* --------------- Agent Channel Settings APIs --------------- */
  async getAgentChannelSettings() {
    try {
      const res = await transport.get("/api/conversation/agent_channel_settings");
      return res.data;
    } catch (error) {
      console.error("Error fetching agent channel settings:", error);
      throw error;
    }
  },

  async updateAgentChannelSettings(data) {
    try {
      const res = await transport.post("/api/conversation/agent_channel_settings", data);
      return res.data;
    } catch (error) {
      console.error("Error updating agent channel settings:", error);
      throw error;
    }
  },

  async toggleAgentChannel(data) {
    try {
      const res = await transport.post("/api/conversation/agent_channel_settings/toggle", data);
      return res.data;
    } catch (error) {
      console.error("Error toggling agent channel:", error);
      throw error;
    }
  },

  /* --------------- Support WhatsApp APIs --------------- */
  async getSupportWhatsAppSettings() {
    try {
      const res = await transport.get("/api/conversation/support_whatsapp/settings");
      return res.data;
    } catch (error) {
      console.error("Error fetching support WhatsApp settings:", error);
      throw error;
    }
  },

  async updateSupportWhatsAppSettings(data) {
    try {
      const res = await transport.post("/api/conversation/support_whatsapp/settings", data);
      return res.data;
    } catch (error) {
      console.error("Error updating support WhatsApp settings:", error);
      throw error;
    }
  },

  /* --------------- Support Email APIs --------------- */
  email:{
  async getSupportEmailSettings() {
    try {
      const res = await transport.get("/api/conversation/support_email/settings");
      return res.data;
    } catch (error) {
      console.error("Error fetching support email settings:", error);
      throw error;
    }
  },

  async updateSupportEmailSettings(payload) {
    try {
      const res = await transport.post("/api/conversation/support_email/settings", payload);
      return res.data;
    } catch (error) {
      console.error("Error updating support email settings:", error);
      throw error;
    }
  },

  async fetchEmailThreads(leadEmail, conversationId = null) {
    try {
      const params = { lead_email: leadEmail };
      if (conversationId) {
        params.conversation_id = conversationId;
      }
      
      const res = await transport.get("/api/conversation/support_email/threads", {
        params: params,
      });
      return res.data;
    } catch (error) {
      console.error("Error fetching email threads:", error);
      throw error;
    }
  },

  async getConfiguredMailboxIds() {
    try {
      const res = await transport.get("/api/conversation/support_email/configured_mailboxes");
      return res.data;
    } catch (error) {
      console.error("Error fetching configured mailbox IDs:", error);
      throw error;
    }
  },
},
};
